import { render, staticRenderFns } from "./ReadOnlyZoneObservation.vue?vue&type=template&id=2a78711a&"
import script from "./ReadOnlyZoneObservation.vue?vue&type=script&lang=js&"
export * from "./ReadOnlyZoneObservation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports